import React from 'react';
import { Link } from 'react-router-dom';
import { InfinityIcon, TruckIcon, LayersIcon, MailIcon, ShieldIcon } from 'lucide-react';
import { UspsBadge } from './UspsBadge';
import { PaymentLogos } from './PaymentLogos';
const promises = [{
  icon: InfinityIcon,
  title: 'Lifetime Replacement Warranty',
  body: 'Break it. We replace it. Terms apply.',
  gold: true
}, {
  icon: LayersIcon,
  title: '3 lenses in every box',
  body: 'Clear, Amber and Smoke included.'
}, {
  icon: TruckIcon,
  title: 'Free U.S. shipping',
  body: 'Free standard shipping on orders of $99.90+.'
}, {
  icon: ShieldIcon,
  title: 'Built for real work',
  body: 'Made for people who use their hands.'
}];
const columns = [{
  title: 'Shop',
  links: [{
    label: '1 X1 system for $49.95',
    href: '/#offer'
  }, {
    label: 'Buy 2, get 1 free: $99.90',
    href: '/#offer'
  }, {
    label: 'Buy 4, get 2 free: $199.80',
    href: '/#offer'
  }, {
    label: 'Business / crew pack: $999.00',
    href: '/#offer'
  }]
}, {
  title: 'Product',
  links: [{
    label: 'The 3-lens system',
    href: '/#lenses'
  }, {
    label: 'Product details',
    href: '/#details'
  }, {
    label: 'Specs & answers',
    href: '/#specs'
  }, {
    label: 'How it compares',
    href: '/#why'
  }]
}, {
  title: 'Support',
  links: [{
    label: 'Lifetime replacement',
    href: '/#guarantee'
  }, {
    label: 'Shipping & returns',
    href: '/#shipping'
  }, {
    label: 'Reviews',
    href: '/#reviews'
  }, {
    label: 'FAQ',
    href: '/#faq'
  }, {
    label: 'Verify your GritVue',
    href: '/verify'
  }, {
    label: 'Crew Rewards',
    href: '/rewards'
  }, {
    label: 'Contact us',
    href: '/legal/contact'
  }]
}];
const legal = [{
  label: 'Privacy policy',
  to: '/legal/privacy'
}, {
  label: 'Terms of service',
  to: '/legal/terms'
}, {
  label: 'Returns & refunds',
  to: '/legal/returns'
}, {
  label: 'Shipping policy',
  to: '/legal/shipping'
}, {
  label: 'Lifetime guarantee terms',
  to: '/legal/guarantee'
}, {
  label: 'Legal notice & safety',
  to: '/legal/legal-notice'
}, {
  label: 'Contact us',
  to: '/legal/contact'
}];
export function SiteFooter() {
  return <footer id="support" className="scroll-mt-20 bg-ink-950" data-id="element-845" data-mp="2h1qh01zg4d67">
      <div className="border-y border-white/10 bg-ink-900" data-id="element-846" data-mp="2d16mz7a65poa">
        <ul className="mx-auto grid max-w-[1400px] gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-847" data-mp="283500b9mh67j">
          {promises.map(promise => {
          const Icon = promise.icon;
          return <li key={promise.title} className={`flex items-start gap-3 px-5 py-6 lg:px-6 ${promise.gold ? 'bg-[#1a1408]' : 'bg-ink-900'}`} data-id="element-848" data-mp="1ydlh55lwtcco">
                <Icon className={`mt-0.5 h-6 w-6 shrink-0 ${promise.gold ? 'text-[#f2c94c]' : 'text-grit-500'}`} aria-hidden="true" data-id="element-849" data-mp="1pdopcv483xde" />
                <span data-id="element-850" data-mp="1fdxwexvb9qff">
                  <span className={`block font-display text-lg font-bold uppercase leading-tight tracking-wide ${promise.gold ? 'gold-text' : 'text-offwhite'}`} data-id="element-851" data-mp="1ffsdu27dj0er">
                    {promise.title}
                  </span>
                  <span className="mt-1 block text-[13px] text-steel-400" data-id="element-852" data-mp="4v4f1bly5u4f">{promise.body}</span>
                </span>
              </li>;
        })}
        </ul>
      </div>

      <div className="mx-auto grid max-w-[1400px] gap-10 px-4 py-14 sm:px-6 lg:grid-cols-[1.5fr_1fr_1fr_1fr] lg:px-8 lg:py-16" data-id="element-853" data-mp="38ce6viaavfpf">
        <div data-id="element-854" data-mp="3dao2tv3umkc3">
          <span className="block font-display text-4xl font-extrabold uppercase leading-none tracking-tight text-offwhite" data-id="element-855" data-mp="3d81xm24fkgx1">
            Grit<span className="text-grit-500" data-id="element-856" data-mp="3m39kf7vqukzc">Vue</span>
            <sup className="ml-1 align-super text-[11px] text-steel-500" data-id="element-857" data-mp="3m415vpvmn2bw">™</sup>
          </span>
          <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.34em] text-steel-400" data-id="element-858" data-mp="2pklf1r6yw0ja">
            See the job through
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-steel-400" data-id="element-859" data-mp="2ah0tih5rv3tw">
            GritVue X1 is illuminated work eyewear with built-in hands-free light and three interchangeable lenses.
            Designed for mechanics, builders, techs, drivers and anyone who works with their hands.
          </p>
          <div className="mt-6 border border-white/12 bg-ink-900 p-5" data-id="element-860" data-mp="2ffvjc325psni">
            <h2 className="font-display text-xl font-bold uppercase tracking-wide text-offwhite" data-id="element-861" data-mp="2t81pqxficl9r">
              Support &amp; contact
            </h2>
            <p className="mt-2 text-sm text-steel-400" data-id="element-862" data-mp="2o8p6emnuhwbx">
              Questions, order help or a lifetime replacement claim. A real person answers.
            </p>
            <a href="mailto:support@gritvuegear.com" className="mt-4 inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-863" data-mp="2y74wqnf1t1kd">
              <MailIcon className="h-4 w-4 text-grit-500" aria-hidden="true" data-id="element-864" data-mp="13vq5212h8s1z" />
              support@gritvuegear.com
            </a>
            <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-steel-500" data-id="element-865" data-mp="3kgbouh2psxr8">
              Monday to Friday · 8am to 6pm CT
            </p>
            <address className="mt-5 border-t border-white/10 pt-4 text-[13px] not-italic leading-relaxed text-steel-400" data-id="element-866" data-mp="35ot9mlhoj78x">
              <span className="block text-[10px] font-bold uppercase tracking-[0.22em] text-steel-500" data-id="element-867" data-mp="2wqhb7xakn55x">
                U.S. fulfillment network
              </span>
              GritVue Gear ships from U.S. warehouses in Fort Worth, TX, Tampa, FL and Los Angeles, CA.
            </address>
            <div className="mt-4" data-id="element-868" data-mp="2rr4qbi39g85z">
              <UspsBadge data-id="element-869" data-mp="2rs7e3h5aduho" />
            </div>
          </div>
        </div>

        {columns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-870" data-mp="l1zvg4k7ko8d">
            <h2 className="font-display text-lg font-bold uppercase tracking-[0.12em] text-offwhite" data-id="element-871" data-mp="pzj6kvlm0kw3">
              {column.title}
            </h2>
            <ul className="mt-5 grid gap-3" data-id="element-872" data-mp="ok71b4rrlopn">
              {column.links.map(link => <li key={link.label} data-id="element-873" data-mp="jiq53mk86qfe">
                  <Link to={link.href} className="text-sm text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-874" data-mp="jlvruv5dtg7y">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>)}
      </div>

      <div className="border-t border-white/10" data-id="element-875" data-mp="12b235x3uj5jq">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-6 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-876" data-mp="12cd65upgw99s">
          <nav aria-label="Legal" data-id="element-877" data-mp="skzaxz4jtvmg">
            <ul className="flex flex-wrap gap-x-6 gap-y-2" data-id="element-878" data-mp="sjxpd0pwpqqh">
              {legal.map(item => <li key={item.label} data-id="element-879" data-mp="1q0wega8iom1v">
                  <Link to={item.to} className="text-xs font-semibold uppercase tracking-wide text-steel-400 transition-colors duration-150 ease-grit hover:text-grit-500" data-id="element-880" data-mp="1l94ysuqwg0qi">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div data-id="element-881" data-mp="22gw34ol07cba">
            <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-steel-500" data-id="element-882" data-mp="22ka4bthxlfh5">Secure checkout</p>
            <div className="mt-2" data-id="element-883" data-mp="2cgd813sflm67">
              <PaymentLogos data-id="element-884" data-mp="2ch6f65vaydov" />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-885" data-mp="2ghgkrhf6n237">
        <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-6 sm:px-6 lg:flex-row lg:items-center lg:justify-between lg:px-8" data-id="element-886" data-mp="2gg5mfx4iamjh">
          <p className="text-xs text-steel-500" data-id="element-887" data-mp="2q8b9qtjtcfsc">© {new Date().getFullYear()} GritVue. All rights reserved.</p>
          <p className="max-w-xl text-xs leading-relaxed text-steel-500" data-id="element-888" data-mp="2v7nwleaopmux">
            GritVue X1. Illuminated work glasses with built-in hands-free light and three interchangeable lenses.
          </p>
          <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-steel-400" data-id="element-889" data-mp="3lg4px5axh0kr">Light where you look</p>
        </div>
      </div>
    </footer>;
}